import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, Loading, getResources, usePermissions } from 'react-admin';
import { withRouter } from 'react-router-dom';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PeopleIcon from '@material-ui/icons/People';
import ViewListIcon from '@material-ui/icons/ViewList';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CategoryIcon from '@material-ui/icons/Category';

const hideResources = ['categories', 'users', 'art-types', 'providers', 'places', 'report'];

const Menu = ({ onMenuClick, logout }) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  const { loading, loaded, permissions } = usePermissions();

  if (loading && !loaded) return <Loading />;
  return (
    <div style={{ marginTop: 30 }}>
      <MenuItemLink
        to="/"
        primaryText="Dashboard"
        leftIcon={<DashboardIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      {resources.map((resource) => {
        if (!hideResources.includes(resource.name))
          return (
            <MenuItemLink
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={(resource.options && resource.options.label) || resource.name}
              leftIcon={<ViewListIcon />}
              onClick={onMenuClick}
              sidebarIsOpen={open}
            />
          );
        return null;
      })}
      {(permissions === 'MASTER_ADMIN' || permissions === 'ADMIN') && (
        <>
          <MenuItemLink
            to="/providers"
            primaryText="Providers"
            leftIcon={<PeopleIcon />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
          <MenuItemLink
            to="/categories"
            primaryText="Categories"
            leftIcon={<CategoryIcon />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
          <MenuItemLink
              to="/report"
              primaryText="Report"
              leftIcon={<AssessmentIcon />}
              onClick={onMenuClick}
              sidebarIsOpen={open}
          />
          <MenuItemLink
            to="/invite"
            primaryText="Invite New User"
            leftIcon={<PersonAddIcon />}
            onClick={onMenuClick}
            sidebarIsOpen={open}
          />
        </>
      )}
      {isXSmall && logout}
    </div>
  );
};

export default withRouter(Menu);
